import app from 'apps/modules/app/AppReducer';
import receipt from 'apps/modules/receipt/ReceiptReducer';

import { combineReducers } from 'redux-immutable';

export default combineReducers({
  app,
  receipt
});
